import * as ApiUrls from "./ApiUrl.Import";
import { AxiosResponse } from "axios";
import { axiosInstance } from "../AxiosInterceptor";
import { FileExportRequest, FileUploadRequestParameters, FileUploadRequestResponse, UploadRequestParameters } from "../../Model/Dto/Upload";
import config from "../../../config";

export const ImportService = {
    RemoveRedisKeyCheck: (parameters: UploadRequestParameters): Promise<AxiosResponse<boolean>> => axiosInstance.get(ApiUrls.RemoveKey, {params: parameters}),
    UploadFileStuckCheck: (parameters: UploadRequestParameters): Promise<AxiosResponse<{Status: string}>> => axiosInstance.get(ApiUrls.IndRunning, {params: parameters}),
    ExportFile: (request: FileExportRequest): Promise<AxiosResponse<string>> => axiosInstance.post(ApiUrls.FileExport,request),
    DownloadImportHelpfile: (scorecardId: string, sectionId: string)=> {
        const url = `${config.apiUrl}${ApiUrls.ImportHelpfile}/${scorecardId}/${sectionId}`;
        window.open(url);
    },
    DownloadImportTemplate: (scorecardId: string, type: string)=> {
      const url = `${config.apiUrl}${ApiUrls.ImportTemplate}?scorecardId=${scorecardId}&type=${type}`;
      window.open(url);
  },
    UploadFile: (parameters: FileUploadRequestParameters, file: any, setPercentageUpload:  (progress: number) => void): Promise<AxiosResponse<FileUploadRequestResponse>> => {
        const options = {
            onUploadProgress: (progressEvent: any) => {
              const { loaded, total } = progressEvent;
              let percent = Math.floor((loaded * 100) / total)
              setPercentageUpload(percent);
            },
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
          let formData = new FormData();
          formData.append("file", file);

          var url = ApiUrls.FileUpload +
          "?type=" + parameters.ImportType +
          "&ScorecardId=" + parameters.ScorecardId +
          '&ImportAction=' + parameters.ImportAction;

        return axiosInstance.post(url, formData,  options);

    },
}